import { Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" component="div" style={{ fontSize: '4rem', fontWeight: 'bold', color: '#1976d2' }}>
        404
      </Typography>
      <Typography variant="h5" style={{ marginBottom: 20 }}>
        Oops! Strona, której szukasz, nie istnieje.
      </Typography>
      <Button onClick={handleGoHome} variant="contained" color="primary" size="large" style={{ marginTop: 20 }}>
        Wróć na stronę główną
      </Button>
    </Container>
  );
};
